import { render } from "./WeThemeSettingsInput.vue?vue&type=template&id=47b83394"
import script from "./WeThemeSettingsInput.vue?vue&type=script&lang=js"
export * from "./WeThemeSettingsInput.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__